import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, FormSelect, Row } from 'shards-react'
import { setFormData, giaActions } from '../../../../redux/reducers/GIA/giaReducer';
import styles from '../styles.module.css'
import { organizationList } from '../../../../redux/reducers/organization-list-reducer'
import { getYearsList } from '../../../../utils/smallHelpers';
import { ORG_TYPES } from '../../../../constants/const';
import moment from 'moment';


const Form = ({ form }) => {
  
  const year = moment().year()

  const yearsList = getYearsList(year-1, year+1)

  const dispatch = useDispatch()

  const orgList = useSelector(state => state.reports.orgList.data)
  const auth = useSelector(state => state.auth.data)

  useEffect(() => {
    if (orgList !== undefined && orgList.length === 0) {
      dispatch(organizationList.organizationListRequestStart(auth))
    }
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    const school = (name === 'org' && value !== '0') ? "0" : form.school
    dispatch(setFormData({ ...form, school, [name]: value }))
  }

  const onSubmit = () => {
    dispatch(giaActions.giaRequestStart())
  }

  return (
    <Row className={styles.formRow}>
        
        <Col md={2}>
          <label htmlFor="year">Выберите год</label>
          <FormSelect
              id='year'
              name='year'
              size="sm"
              value={form.year}
              onChange={handleChange}
          >
              {yearsList.map(year => <option key={year} value={year} selected={year === form.year}>{year}</option>)}
          </FormSelect>
        </Col>

        <Col md={5}>
          {/* <FormGroup className={'mr-3'}> */}
            <label htmlFor='org'>Выберите организацию</label>
            <FormSelect
              name='org'
              id='org'
              size='sm'
              className='d-block'
              value={form.org}
              onChange={handleChange}
            >
              <option value='0'>Все организации</option>
              {!!orgList && orgList.map(item => (
                <option key={item.idOrganization} value={item.idOrganization}>
                  {item.orgName}
                </option>
              ))}
            </FormSelect>
          {/* </FormGroup> */}
        </Col>

        {form.org === '0' && (
          <Col md={2}>
            {/* <FormGroup> */}
              <label htmlFor='_school'>Тип ОО</label>
              <FormSelect
                name='school'
                id='_school'
                size='sm'
                className='md-block'
                onChange={handleChange}
                value={form.school}
              >
                {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
              </FormSelect>
            {/* </FormGroup> */}
          </Col>
        )}

        <Button style={{margin: '0 15px'}} onClick={onSubmit}>Создать отчет</Button>

    </Row>
  )
}

export default Form